<template>
  <div class="w-1373px h-full overflow-hidden flex">
    <div
      class="flex-1 overflow-hidden flex flex-col p-10px"
      style="border: 1px solid #f4eaff"
    >
      <div class="w-full">
        <div class="text-16px font-bold">请选择模型</div>
        <div class="w-full flex justify-between mt-10px">
          <select-model-type
            class="w-250px"
            v-model="modelType"
            @change="modelTypeChange"
          />
          <wise-select
            class="w-250px"
            v-model="applicationScenario"
            @change="applicationScenarioChange"
          />
          <select-public-or-private
            class="w-150px"
            v-model="publicOrPrivate"
            placeholder="公开/私有"
            @change="publicOrPrivateChange"
          />
          <div class="w-256px">
            <my-input
              placeholder="请输入模型名称"
              v-model="modelName"
              @search="modelNameSearch"
            />
          </div>
        </div>
      </div>
      <div class="flex-1 overflow-hidden mt-10px" v-loading="leftTable.loading">
        <auto-height-table
          :data="tableData"
          :total="leftTable.total"
          multiple
          ref="leftTable"
          @selection-change="leftTableSelectChange"
          @row-click="leftTableRowClick"
          @pagination="leftTablePagination"
        >
          <el-table-column :selectable="canSelect" type="selection" width="55">
          </el-table-column>
          <el-table-column
            v-for="(item, index) in columns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width || 'auto'"
            :show-overflow-tooltip="item.showOverflowTooltip"
          >
          </el-table-column
        ></auto-height-table>
      </div>
    </div>
    <div class="flex flex-col justify-center px-5px">
      <img
        src="@/assets/images/right.png"
        class="w-32px h-32px cursor-pointer"
        :class="{ 'cursor-not-allowed': moveRightDisabled }"
        @click="moveRight"
      />
      <img
        src="@/assets/images/left.png"
        class="w-32px h-32px cursor-pointer mt-20px"
        :class="{ 'cursor-not-allowed': moveLeftDisabled }"
        @click="moveLeft"
      />
    </div>
    <div
      class="w-380px p-10px flex flex-col"
      style="border: 1px solid #f4eaff"
      v-loading="rightTable.loading"
    >
      <div class="text-16px font-bold">已关联模型：{{ rightTable.total }}</div>
      <div class="flex-1 overflow-hidden mt-10px">
        <auto-height-table
          :data="relatedModels"
          multiple
          ref="rightTable"
          :total="rightTable.total"
          :noPagination="true"
          @selection-change="rightTableSelectChange"
          layout="total, prev, pager, next"
          empty-text="当前模型暂未关联任何模型，
您可以通过勾选左侧的模型建立关联"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="project_name_zh"
            label="模型名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="操作" width="100px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="deleteOne(scope.row, scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </auto-height-table>
      </div>
    </div>
  </div>
</template>

<script>
import autoHeightTable from '@/components/auto-height-table.vue'
import selectModelType from '@/components/select-model-type.vue'
import wiseSelect from '@/components/wise-select.vue'
import selectPublicOrPrivate from '@/components/select-public-or-private.vue'
import myInput from '@/components/my-input.vue'
import getNameById from '@/utils/getSelectNameById'

export default {
  components: {
    autoHeightTable,
    selectModelType,
    wiseSelect,
    selectPublicOrPrivate,
    myInput
  },
  props: {
    id: {} // 模型id
  },
  data() {
    return {
      modelType: '',
      applicationScenario: [],
      publicOrPrivate: '',
      modelName: '',
      tableData: [],
      columns: [
        { prop: 'project_name_zh', label: '模型名称' },
        { prop: 'project_category_name', label: '模型类型' },
        {
          prop: 'project_scene_name',
          label: '应用场景',
          showOverflowTooltip: true
        },
        { prop: 'is_public_name', label: '公开/私有' }
      ],
      leftTable: {
        loading: false,
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      rightTable: {
        loading: false,
        total: 0
      },
      leftTableSelectedRows: [],
      rightTableSelectedRows: [],
      relatedModels: []
    }
  },
  computed: {
    moveLeftDisabled() {
      return this.rightTableSelectedRows.length === 0
    },
    moveRightDisabled() {
      return this.leftTableSelectedRows.length === 0
    }
  },
  async created() {
    await this.getTableData()
    if (this.id) {
      await this.getCorrelationModels()
    }
  },
  mounted() {},
  methods: {
    async getTableData() {
      this.leftTable.loading = true
      let data = {
        baseReq: {
          page: this.leftTable.pageNo,
          pageSize: this.leftTable.pageSize
        },
        project_type: 'M'
      }
      if (this.modelType.length > 0) {
        data.project_category_id = this.modelType.slice(-1)[0]
      }
      if (this.applicationScenario.length > 0) {
        data.project_scene_id = this.applicationScenario
      }
      if (this.publicOrPrivate.toString()) {
        data.is_public = this.publicOrPrivate
      }
      if (this.modelName) {
        data.project_name_zh = this.modelName
      }
      this.leftTable.loading = true
      try {
        const res = await this.$api.project.queryprojectlist(data)
        const { message } = res
        if (message === 'Success') {
          this.leftTable.total = res.data.page.allCount
          this.tableData = res.data.list.map((item) => {
            item.project_scene_name = getNameById(
              this.$store.state.selectOptions.applicationScenario,
              item.project_scene_id
            )
            item.project_category_name = getNameById(
              this.$store.state.selectOptions.modelType,
              item.project_category_id
            )
            item.is_public_name = item.is_public ? '公开' : '私有'
            return item
          })
          // 去除刚刚建立的模型
          const index = this.tableData.findIndex((item) => item.Id == this.id)
          if (index > -1) {
            this.tableData.splice(index, 1)
            this.leftTable.total -= 1
          }
          this.setTableRelated()
        }
      } catch (error) {
      } finally {
        this.leftTable.loading = false
      }
    },
    // 关联
    moveRight() {
      const array = this.leftTableSelectedRows.filter((i) => !i.isRelated)
      if (array.length > 0) {
        this.$api.project
          .related({
            id: this.id,
            project_ids: array.map((i) => i.Id)
          })
          .then((res) => {
            if (res.message === 'Success') {
              this.$message.success('关联成功')
              this.leftTableSelectedRows = []
              this.getCorrelationModels() // 更新关联模型列表
            }
          })
      }
    },
    // 取消关联左箭头
    moveLeft() {
      if (this.rightTableSelectedRows.length > 0) {
        this.cancelrelated(this.rightTableSelectedRows.map((item) => item.Id))
      }
    },
    // 取消关联接口
    cancelrelated(project_ids) {
      this.$api.project
        .cancelrelated({
          id: this.id,
          project_ids
        })
        .then((res) => {
          if (res.message === 'Success') {
            this.$message.success('取消关联成功')
            this.getCorrelationModels()
          }
        })
    },
    // 关联模型列表
    async getCorrelationModels() {
      this.rightTable.loading = true
      const data = {
        project_id: this.id,
        project_type: 'M'
      }
      try {
        const res = await this.$api.project.relatelist(data)
        const { message } = res
        if (message === 'Success') {
          this.relatedModels = res.data.list
          this.rightTable.total = res.data.page.allCount
          this.setTableRelated()
        }
      } catch (error) {
      } finally {
        this.rightTable.loading = false
      }
    },
    /**
     * row：当前行数据
     * index：当前第几位
     */
    canSelect(row) {
      return !row.isRelated
    },
    // 行点击事件
    leftTableRowClick(row) {
      if (row.isRelated) {
        return
      }
      const tableEl = this.$refs['leftTable'].getTableRef()
      tableEl.toggleRowSelection(row, true)
    },
    // 设置表格已关联模型选项不可选中
    setTableRelated() {
      this.tableData.forEach((i) => {
        this.$set(i, 'isRelated', false)
        this.relatedModels.forEach((j) => {
          if (j.Id === i.Id) {
            this.$set(i, 'isRelated', true)
          }
        })
      })
    },
    // 清除表格已选项
    clearTableSelected() {
      this.tableData.forEach((item) => {
        this.$refs['leftTable'].getTableRef().toggleRowSelection(item, false) // 对应row改为已选择状态
      })
    },
    // 删除
    deleteOne(row, index) {
      this.cancelrelated([row.Id])
    },
    leftTableSelectChange(selection) {
      this.leftTableSelectedRows = selection
      this.moveRight()
    },
    rightTableSelectChange(selection) {
      this.rightTableSelectedRows = selection
    },
    leftTablePagination({ size, current }) {
      this.leftTable.pageNo = current
      this.leftTable.pageSize = size
      this.getTableData()
    },
    modelTypeChange() {
      this.getTableData()
    },
    applicationScenarioChange() {
      this.getTableData()
    },
    publicOrPrivateChange() {
      this.getTableData()
    },
    modelNameSearch() {
      this.getTableData()
    },
    leftTablePagination({ size, current }) {
      this.leftTable.pageSize = size
      this.leftTable.pageNo = current
      this.getTableData()
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
